// 설레임런 메인 정적 콘텐츠/상수.
// 메인은 정적 프로모션 랜딩(BE 메인 스펙 placeholder)이라 콘텐츠는 디자인 baked 값을 하드코딩.
// 통이미지(raster)는 CDN 서빙(cdn.kottonseed.io) — Header.tsx 컨벤션과 동일.

/** 상단 페이지 탭. 기본값은 '2026 설레임런'(SB 근거). */
export type SeoleimrunTab = 'run' | 'event';

const CDN = 'https://cdn.kottonseed.io/assets/seoleimrun';

/** 통이미지(raster) 자산 — declared(figma) 크기 그대로. 3x webp 업로드됨. */
export const SEOLEIMRUN_IMAGES = {
  // 공유 히어로(기안84 키비쥬얼)
  hero: { src: `${CDN}/main/hero-260710.webp`, width: 480, height: 598 },
  // 탭 A(설레임 이벤트) 본문 슬라이스 — 인터랙션 제거 배경
  eventInfo: { src: `${CDN}/main/event-01-info-260713.webp`, width: 480, height: 460 },
  eventHowTo: { src: `${CDN}/main/event-02-howto.webp`, width: 480, height: 1120 },
  eventPrize: { src: `${CDN}/main/event-03-prize.webp`, width: 480, height: 1511 },
  eventInquiry: { src: `${CDN}/main/event-04-inquiry.webp`, width: 480, height: 334 },
  // 탭 B(2026 설레임런) 상단 서브 키비쥬얼
  runIntro: {
    src: `${CDN}/run/intro.webp`,
    width: 480,
    height: 586,
    alt: '선착순 2,500명 한정! 기안84 도 함께 뛴다! 더 푸짐한 혜택으로 돌아온 2026 설레임 RUN',
  },
} as const;

/**
 * 탭 B(2026 설레임런) 본문 통이미지 — 세로 스택.
 * 원본 단일 프레임(figma 1649:10336, 480x3475)을 배경이 균일한 y=930 / y=2364 에서 분할.
 * 3x 단일 export 는 1440x10425 라 모바일 디코드 부담이 커 3장으로 나눔. 높이 합 = 3475.
 */
export const SEOLEIMRUN_RUN_CONTENTS = [
  {
    src: `${CDN}/run/contents-260710-1.webp`,
    width: 480,
    height: 930,
    alt: '2026 설레임런 행사 정보 — 행사일시 2026년 9월 5일(토), 대회장소 하남 미사경정공원, 참가종목/코스 10km, 참가인원 3,000명(선착순 2,500명 + 이벤트 500명), 접수기간 2026년 7월 13일 10:00 ~ 8월 26일 24:00, 참가비용 64,900원(레이스키트 포함), 주최 (주)롯데웰푸드, 주관 대학내일ES, 후원사 beplain·OFFON·S.NATURE·파스퇴르·EXTREME·Dr.UN:',
  },
  {
    src: `${CDN}/run/contents-260710-2.webp`,
    width: 480,
    height: 1434,
    alt: '코스안내 10km — 미사경정공원 남문 출발, P6·P7·P3 주차장을 거쳐 미사경정공원 남문 도착. 레이스키트 구성 — 01 리에티X비비 DASH 스포츠 선글라스(소비자가 79,900원), 02 설레임런 기능성 티셔츠, 03 설레임런 슬로건 타올, 04 설레임런 스포츠 짐색, 05 배번표 & 기록칩 & 완주메달',
  },
  {
    src: `${CDN}/run/contents-260710-3.webp`,
    width: 480,
    height: 1111,
    alt: '체험 키트 — 비플레인 녹두 선크림, 오프온 쿨링 진정 바디미스트 150ml, 에스네이처 아쿠아 스쿠알란 수분크림 10ml, 파스퇴르 단백질플러스 음료, 익스트림 엑티브 에너지젤 1포, 닥터언 밀크씨슬 1팩. 기념품은 계속 추가될 예정. 완주 키트 — 롯데 과자 선물 상자(선물 구성은 변경될 수 있음)',
  },
] as const;

/**
 * 회차 경품 카드(통이미지) — 회차 탭으로 스왑.
 * 회차 기간은 겹칠 수 있다(2차 시작 07/14 < 1차 종료 07/19). 기본 선택 회차는 종료일이 아니라
 * `startAt` 기준 — 시작한 회차 중 가장 마지막 회차(useEventPhase). 겹치는 구간에선 신규 회차 우선.
 */
export const SEOLEIMRUN_ROUNDS = [
  {
    label: '1차 경품',
    image: { src: `${CDN}/main/prize-round-1.webp`, width: 320, height: 472 },
    // 1차 기간 07/03 ~ 07/19
    startAt: Date.parse('2026-07-03T00:00:00+09:00'),
  },
  {
    label: '2차 경품',
    image: { src: `${CDN}/main/prize-round-2-260713.webp`, width: 320, height: 472 },
    // 2차 기간 07/14 ~ 08/14
    startAt: Date.parse('2026-07-14T00:00:00+09:00'),
  },
  {
    label: '3차 경품',
    image: { src: `${CDN}/main/prize-round-3.webp`, width: 320, height: 472 },
    // 3차 기간 08/15 ~ 09/04
    startAt: Date.parse('2026-08-15T00:00:00+09:00'),
  },
] as const;

/** 이벤트 종료 시각(KST). 대회 종료 후(9/6~) 액션 버튼 클릭 시 종료 모달. */
export const SEOLEIMRUN_END_AT = Date.parse('2026-09-06T00:00:00+09:00');

/** 접수 오픈 시각(KST). 이 시각부터 하단 공지사항/유의사항 버튼 노출. */
export const SEOLEIMRUN_FOOTER_NOTICE_OPEN_AT = Date.parse('2026-07-10T10:00:00+09:00');

/** 참가 접수 오픈 시각(KST). 이 시각 전에는 히어로 "설레임런 신청하기" 클릭 시 안내 모달. */
export const SEOLEIMRUN_APPLY_OPEN_AT = Date.parse('2026-07-13T10:00:00+09:00');

/** 네비게이션 경로 (Phase 4 확정). */
export const SEOLEIMRUN_LINKS = {
  mySeoleim: '/seoleimrun/my',
  apply: '/seoleimrun/apply',
  gift: '/seoleimrun/gift',
  receipt: '/seoleimrun/receipt',
  // category=설레임 → qna/write 에서 "설레임런" 문의유형으로 고정 선택.
  inquiry: '/support/qna/write?category=설레임',
  // 공지사항: 6차 디자인에서 하단 버튼이 제외됨. 재노출 대비해 링크만 존치(노션 페이지 미등록).
  notice: '/notion-app/seoleimrun/notice',
  caution: '/notion-app/seoleimrun/caution',
} as const;

/** MY 설레임 메뉴 → 내역/상세 페이지 경로. ⚠️ 내역 페이지는 후속 티켓에서 구현(현재 라우트 미생성). */
export const SEOLEIMRUN_MY_LINKS = {
  apply: '/seoleimrun/my/apply',
  gift: '/seoleimrun/my/gift',
  receipt: '/seoleimrun/my/receipt',
  luckydraw: '/seoleimrun/my/luckydraw',
  /** 프로필 편집 (공통 마이페이지). */
  profileEdit: '/mypage/profile',
} as const;

/**
 * 탭 B(2026 설레임런) 하단 버튼 row.
 * gated: 접수 오픈(SEOLEIMRUN_FOOTER_NOTICE_OPEN_AT) 이후에만 노출.
 */
export const SEOLEIMRUN_FOOTER_BUTTONS = [
  { label: '유의사항 확인', href: SEOLEIMRUN_LINKS.caution, gated: true },
  { label: '1:1 문의', href: SEOLEIMRUN_LINKS.inquiry, gated: false },
] as const;

/** 탭 B FAQ — 디자인 1637:10930(FAQ_전체 펼쳐짐) 정확본(Q + A). */
export const SEOLEIMRUN_FAQ = [
  {
    q: '참가 신청이 정상적으로 완료되었는지 어디에서 확인할 수 있나요?',
    a: '프로모션 사이트의 [마이페이지>신청 내역]에서 참가 신청 및 결제 완료 여부를 확인하실 수 있습니다. 결제가 정상적으로 완료되어야 최종 참가자로 등록됩니다.',
  },
  {
    q: '신청 정보나 배송지를 수정할 수 있나요?',
    a: '결제 이후 신청 정보, 배송지, 기념품 사이즈 정보 수정은 1:1 문의를 통해서만 가능합니다. 특히 8월 21일 24:00 마감 이후에는 참가자 물품 제작 및 배송 준비로 인해 변경이 어렵습니다.',
  },
  {
    q: '참가 신청을 취소하거나 환불 받을 수 있나요?',
    a: `참가 취소 및 환불은 아래의 환불 규정에 따라 환불이 가능합니다. 기간 이후에는 기념품 및 참가 물품 제작이 진행되어 개인 사정이나 부상 등의 사유로도 취소 및 환불이 어려울 수 있습니다.
-결제 후 7일 이내: 전액 환불 가능
-결제 후 8일 이후 ~ 26년 8월 21일: 취소 수수료 공제 후 환불 가능
-26년 8월 21일 이후: 환불 불가
-행사 당일 불참: 환불 불가`,
  },
  {
    q: '참가권을 다른 사람에게 양도할 수 있나요?',
    a: '참가권은 신청자 본인만 사용할 수 있으며, 타인에게 양도·판매하거나 대리 참가하는 것은 불가합니다. 실제 참가자와 신청자 정보가 다를 경우 기록 인정, 보험 적용 및 행사 참여가 제한됩니다.',
  },
  {
    q: '배번표와 참가 기념품은 언제 받을 수 있나요?',
    a: `배번표, 기록칩 및 참가 기념품은 택배 사전 배송 방식으로 제공됩니다. 세부 일정과 수령 방법은 대회 전 참가자 안내 메시지를 통해 공지해 드립니다.
배송지 오기재로 인한 오배송 및 미수령에 대해서는 주최사 및 운영사가 책임지지 않습니다.`,
  },
  {
    q: '대회 당일 반드시 지참해야 하는 준비물이 있나요?',
    a: '사전에 지급된 배번표와 기록칩을 반드시 지참해 주세요. 배번표는 잘 보이도록 상의 앞면에 부착해야 하며, 기록칩을 착용하지 않거나 측정 구간을 통과하지 않을 경우 기록이 정상적으로 측정되지 않을 수 있습니다.',
  },
  {
    q: '대회 당일 몇 시까지 어디로 가야 하나요?',
    a: '참가자는 출발 준비와 물품보관을 위해 출발 시간보다 여유 있게 대회장에 도착해 주세요. 행사 당일 07시부터 행사장이 오픈 될 예정이며, 그룹별 출발 순서는 대회 전 별도 안내될 예정입니다.',
  },
  {
    q: '물품보관소를 운영하나요?',
    a: '대회장 내 참가자 물품보관소를 운영할 예정입니다. 지정된 물품보관 가방만 이용할 수 있으며, 귀중품과 파손 위험이 있는 물품은 보관이 제한될 수 있으므로 가급적 지참하지 않는 것을 권장합니다.',
  },
  {
    q: '개인 기록은 어떻게 측정하고 확인하나요?',
    a: '참가자의 기록은 배번표에 부착된 기록칩을 통해 측정됩니다. 출발점, 코스 내 측정 지점 및 도착점의 기록 매트를 모두 통과해야 정상적으로 기록이 집계됩니다. 완주 기록은 레이스 완주 이후 30분 이내에 참가자가 신청할 때 기입한 핸드폰 번호로 기록증을 다운받을 수 있는 링크가 발송이 됩니다.',
  },
  {
    q: '우천 등 기상 상황으로 행사 취소는 어떻게 확인하나요?',
    a: `기상 상황 등을 행사 전까지 확인하여 대회의 진행이 어렵다고 판단 될 경우 참가 신청하신 전화번호로 안내 문자가 발송되며, 홈페이지 내 팝업을 통해 안내드릴 예정입니다. 취소 안내 문자를 받지 않으신 경우에는 정상적으로 행사가 진행됩니다.
※ 만약 자연재해, 천재지변, 국가 비상상황 등으로 행사가 취소될 경우 참가비는 환불되지 않음을 참고 부탁드립니다.`,
  },
] as const;

/**
 * 접속 지연 안내 모달 콘텐츠 — 트래픽 폭주 시 안내(Figma 1689:10392 "지연 안내 모달").
 * 전역 `openAlertModal({ icon: 'danger' })` 로 노출 → `[data-brand="seoleimrun"]` 토큰이
 * 아이콘(--color-modal-icon = #1C34D3)·확인 버튼(--color-modal-button-primary)을 자동 브랜딩.
 * flag `seoleimrun-delay-notice` 로 gate(트래픽 정상화 시 무배포 OFF).
 * description 의 빈 문자열은 문단 사이 간격 — BaseModalDescription 이 배열을 <br> 로 조인.
 */
export const SEOLEIMRUN_DELAY_NOTICE = {
  title: ['사이트 접속 지연 안내'],
  description: [
    '2026 설레임런에 보내주신',
    '큰 관심에 감사드립니다.',
    '',
    '현재 접속자가 일시적으로 증가하여',
    '사이트 이용이 지연되고 있습니다.',
    '',
    '잠시 후 다시 접속해 주시면 보다',
    '원활하게 이용할 수 있습니다.',
    '',
    '이용에 불편을 드려 죄송하며,',
    '빠른 정상화를 위해 최선을 다하겠습니다.',
  ],
};
